import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, mergeApplicationConfig } from '@angular/core';
import { commonAppConfig } from '@ui/layout/common-app/common-app.config';
import { AppRoutingModule } from './app-routing.module';
import { ThirdLevelMenuFactory } from '@core/menu/third-level-menu.service';
import { thirdLevelMenu } from './sub.menu';
import { DiscountProgramState } from './shared/state/discount-program.state';


export const loadSubMenu: (thirdLevelMenuFactory: ThirdLevelMenuFactory) => () => Promise<boolean> =
    (thirdLevelMenuFactory: ThirdLevelMenuFactory) => () =>
        thirdLevelMenuFactory.loadMenu(thirdLevelMenu);

export const appConfig: ApplicationConfig = mergeApplicationConfig(commonAppConfig, {
    providers: [
        importProvidersFrom(AppRoutingModule),
        {
            provide: APP_INITIALIZER,
            useFactory: loadSubMenu,
            deps: [ThirdLevelMenuFactory],
            multi: true,
        },
        DiscountProgramState,
    ],
});
